__turbopack_context__.v({
  "account": "DocumentCard-module__na5w3W__account",
  "card": "DocumentCard-module__na5w3W__card",
  "title": "DocumentCard-module__na5w3W__title",
});
